/**
 * Widget de chat DLUZ — se agrega al tema de Shopify (por ejemplo, en
 * theme.liquid, justo antes de </body>) como un <script src="..."></script>
 * apuntando a este archivo ya publicado en el hosting del backend, o
 * incluyendo su contenido directamente en un bloque <script> del tema.
 *
 * Comparte el mismo backend (misma conversación, misma extracción de datos,
 * mismo reporte por correo) que el canal de WhatsApp — la única diferencia
 * es que la conversación ocurre directamente en la página, sin salir a
 * WhatsApp.
 *
 * Configuración: cambiar API_BASE_URL por la URL real del backend una vez
 * desplegado en cPanel (ej. "https://api.dluz.cl" o el subdominio que se
 * haya configurado en "Setup Node.js App").
 */
(function () {
const API_BASE_URL = "https://bot.dluz.cl";

function generateSessionId() {
return "web-" + Math.random().toString(36).slice(2) + Date.now();
}

const sessionId =
sessionStorage.getItem("dluz_chat_session") || generateSessionId();
sessionStorage.setItem("dluz_chat_session", sessionId);

const styles = `
#dluz-chat-bubble {
position: fixed; bottom: 24px; right: 24px; width: 60px; height: 60px;
border-radius: 50%; background: #ff7a1a; color: #fff; display: flex;
align-items: center; justify-content: center; cursor: pointer;
box-shadow: 0 4px 12px rgba(0,0,0,.2); z-index: 9999; font-size: 26px;
}
#dluz-chat-window {
position: fixed; bottom: 96px; right: 24px; width: 340px; max-width: 90vw;
height: 460px; background: #fff; border-radius: 12px; box-shadow: 0 8px 30px rgba(0,0,0,.25);
display: none; flex-direction: column; overflow: hidden; z-index: 9999; font-family: sans-serif;
}
#dluz-chat-header { background: #ff7a1a; color: #fff; padding: 12px 16px; font-weight: 600; }
#dluz-chat-messages { flex: 1; padding: 12px; overflow-y: auto; font-size: 14px; }
.dluz-msg { margin-bottom: 10px; line-height: 1.4; white-space: pre-wrap; }
.dluz-msg.user { text-align: right; color: #1a1a1a; }
.dluz-msg.bot { text-align: left; color: #333; }
.dluz-msg .bubble { display: inline-block; padding: 8px 12px; border-radius: 10px; max-width: 85%; }
.dluz-msg.user .bubble { background: #ffe4cc; }
.dluz-msg.bot .bubble { background: #f1f1f1; }
#dluz-chat-input-row { display: flex; border-top: 1px solid #eee; align-items: center; }
#dluz-chat-input { flex: 1; border: none; padding: 10px; font-size: 14px; }
#dluz-chat-attach { border: none; background: none; font-size: 18px; padding: 0 8px; cursor: pointer; }
#dluz-chat-send { border: none; background: #ff7a1a; color: #fff; padding: 0 16px; cursor: pointer; }
.dluz-quick-replies { display: flex; flex-direction: column; gap: 6px; margin: 4px 0 12px; align-items: flex-start; }
.dluz-quick-reply-btn {
border: 1px solid #ff7a1a; background: #fff; color: #ff7a1a; border-radius: 16px;
padding: 7px 14px; font-size: 13px; cursor: pointer; font-family: inherit;
}
.dluz-quick-reply-btn:hover { background: #fff1e6; }
.dluz-quick-reply-btn:disabled { opacity: 0.5; cursor: default; }
`;

const styleTag = document.createElement("style");
styleTag.textContent = styles;
document.head.appendChild(styleTag);

const bubble = document.createElement("div");
bubble.id = "dluz-chat-bubble";
bubble.innerHTML = "💬";
document.body.appendChild(bubble);

const win = document.createElement("div");
win.id = "dluz-chat-window";
win.innerHTML = `
<div id="dluz-chat-header">DLUZ Iluminación</div>
<div id="dluz-chat-messages"></div>
<div id="dluz-chat-input-row">
<button id="dluz-chat-attach" title="Adjuntar foto o plano">📎</button>
<input id="dluz-chat-file" type="file" accept="image/*,.pdf,.dwg" style="display:none" />
<input id="dluz-chat-input" type="text" placeholder="Escribe tu consulta..." />
<button id="dluz-chat-send">Enviar</button>
</div>
`;
document.body.appendChild(win);

const messagesEl = win.querySelector("#dluz-chat-messages");
const inputEl = win.querySelector("#dluz-chat-input");
const sendBtn = win.querySelector("#dluz-chat-send");
const attachBtn = win.querySelector("#dluz-chat-attach");
const fileInput = win.querySelector("#dluz-chat-file");

let opened = false;
bubble.addEventListener("click", async () => {
win.style.display = win.style.display === "flex" ? "none" : "flex";
if (win.style.display === "flex" && !opened) {
opened = true;
await sendToBackend(""); // dispara el mensaje de bienvenida
}
});

function appendMessage(text, who) {
const div = document.createElement("div");
div.className = "dluz-msg " + who;
div.innerHTML = `<span class="bubble"></span>`;
div.querySelector(".bubble").textContent = text;
messagesEl.appendChild(div);
messagesEl.scrollTop = messagesEl.scrollHeight;
}

// Botones de respuesta rápida (mismo mecanismo que los botones nativos de
// WhatsApp, ver WELCOME_BUTTONS en conversation.js): el cliente toca en
// vez de escribir, para avanzar más rápido con menos fricción.
function appendQuickReplies(buttons) {
if (!buttons || !buttons.length) return;
const row = document.createElement("div");
row.className = "dluz-quick-replies";
buttons.forEach((btn) => {
const el = document.createElement("button");
el.type = "button";
el.className = "dluz-quick-reply-btn";
el.textContent = btn.title;
el.addEventListener("click", () => {
// Deshabilita todos los botones de esta fila para que no se pueda
// tocar dos veces ni usar una opción vieja tras avanzar la conversación.
row.querySelectorAll("button").forEach((b) => (b.disabled = true));
sendToBackend(btn.id, btn.title);
});
row.appendChild(el);
});
messagesEl.appendChild(row);
messagesEl.scrollTop = messagesEl.scrollHeight;
}

// `displayText` es opcional: lo que se muestra en la burbuja del usuario
// (ej. "Cotización") cuando `message` es en realidad el id interno del
// botón (ej. "1") que espera el backend.
async function sendToBackend(message, displayText) {
if (message) appendMessage(displayText || message, "user");
try {
const res = await fetch(`${API_BASE_URL}/api/widget/message`, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify({ session_id: sessionId, message: message || "hola" }),
});
const data = await res.json();
appendMessage(data.reply, "bot");
appendQuickReplies(data.buttons);
} catch (err) {
appendMessage(
"Perdona, tuvimos un problema técnico. Puedes escribirnos directo a info@dluz.cl mientras lo resolvemos.",
"bot"
);
}
}

sendBtn.addEventListener("click", () => {
const text = inputEl.value.trim();
if (!text) return;
inputEl.value = "";
sendToBackend(text);
});
inputEl.addEventListener("keydown", (e) => {
if (e.key === "Enter") sendBtn.click();
});

attachBtn.addEventListener("click", () => fileInput.click());
fileInput.addEventListener("change", async () => {
const file = fileInput.files[0];
if (!file) return;
appendMessage(`📎 ${file.name}`, "user");

const formData = new FormData();
formData.append("session_id", sessionId);
formData.append("caption", inputEl.value.trim());
formData.append("file", file);
inputEl.value = "";
fileInput.value = "";

try {
const res = await fetch(`${API_BASE_URL}/api/widget/upload`, {
method: "POST",
body: formData,
});
const data = await res.json();
appendMessage(data.reply, "bot");
appendQuickReplies(data.buttons);
} catch (err) {
appendMessage(
"No pude recibir el archivo por un problema técnico. Puedes enviarlo directo a info@dluz.cl mientras lo resolvemos.",
"bot"
);
}
});
})();
